import { useFormatDate } from "#hooks/useFormatDate.ts";
import type { Conversation } from "#types/types.ts";
import { Div, Text } from "@hopper-ui/components";

interface Props {
    conversation: Conversation;
}
export const ConversationStartDate = ({ conversation }: Props) => {
    const formatDate = useFormatDate();

    if (conversation.messages.length === 0) {
        return null;
    }

    const startDate = formatDate(conversation.messages[0].timestamp, { showRelativeToday: true });

    return (
        <Div textAlign="center">
            <Text
                size="xs"
                fontFamily="overline"
                textTransform="uppercase"
                color="neutral-weak"
            >
                {startDate}
            </Text>
        </Div>
    );
};
